document.addEventListener('DOMContentLoaded', function () {
  var mainImg = document.getElementById('mainProductImage');
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      mainImg.src = thumb.dataset.full;
      mainImg.alt = thumb.dataset.alt || '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});